import { css } from '@emotion/react';
import { alpha } from '@mui/material/styles';

const makeAppointmentAccordionStyles = ({ theme }) => {
  // The theme's CTA green, so the header strip tracks the form's theme rather
  // than a hardcoded colour.
  const green = theme.mvf.palette.component.continueButtonColor;

  return {
    accordion: css({ marginBottom: 20 }),
    accordionToggle: css({
      width: '100%',
      textTransform: 'none',
      padding: '10px 15px',
      // Closed: rounded all four corners. Open: top corners only, so the body
      // below meets it flush (see accordionToggleOpen).
      borderRadius: 4,
      backgroundColor: alpha(green, 0.1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: theme.mvf.palette.text.primaryTextColor,
      '& p': { fontWeight: theme.mvf.typography.weight.thick },
      '&:hover': { backgroundColor: alpha(green, 0.15) },
    }),
    accordionToggleOpen: css({ borderRadius: '4px 4px 0 0' }),
    chevron: css({
      transform: 'rotate(90deg)',
      transition: 'transform 350ms ease-in-out',
      fontSize: 20,
      lineHeight: 1,
    }),
    chevronOpen: css({ transform: 'rotate(-90deg)' }),
    accordionBody: css({
      // No top border: the green header strip is the sole separator between the
      // header and the body.
      borderStyle: 'solid',
      borderColor: alpha(green, 0.4),
      borderWidth: '0 1px 1px',
      borderRadius: '0 0 4px 4px',
      padding: '1rem 15px',
      textAlign: 'left',
      '& p': { textAlign: 'left' },
    }),
  };
};

export default makeAppointmentAccordionStyles;
